import { Skeleton, SkeletonProps } from "@mui/material"
import { FC } from "react"

type IProps = SkeletonProps & {
  isLoading: boolean
  children: React.ReactElement
}
export const SkeletonLoading: FC<IProps> = ({
  isLoading,
  children,
  ...props
}) => {
  if (isLoading) {
    return <Skeleton animation="wave" {...props} />
  }

  return children
}
